import { has } from 'lodash';
import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    filteredById: {},
    sortOrder: []
});

export default (state = getInitialState(), action) => {
    let newById;
    let globalContentRow;
    let reduced;
    switch (action.type) {
        case ACTIONS.PUT_GLOBAL_CONTENT_ROW_SUCCESS:
        case ACTIONS.POST_GLOBAL_CONTENT_ROW_SUCCESS:
        case ACTIONS.GET_GLOBAL_CONTENT_ROW: {
            ({ globalContentRow } = action.payload);

            newById = {
                ...state.byId
            };

            if (has(globalContentRow, '_id')) {
                if (globalContentRow.isDeleted) {
                    newById[globalContentRow._id] = undefined;
                } else {
                    newById[globalContentRow._id] = globalContentRow;
                }
            }

            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.GET_MANY_GLOBAL_CONTENT_ROWS: {
            newById = {
                ...state.byId
            };

            reduced = (action.payload.globalContentRows || []).forEach((globalContentRow) => {
                newById[globalContentRow._id] = {
                    ...newById[globalContentRow._id],
                    ...globalContentRow
                };
            });
            return {
                ...state,
                byId: newById
            };
        }

        case ACTIONS.GET_FILTERED_GLOBAL_CONTENT_ROWS:
            reduced = (action.payload.globalContentRows || []).reduce((prev, globalContentRow) => {
                prev[globalContentRow._id] = globalContentRow;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };

            return {
                ...state,
                byId: newById,
                filteredById: reduced
            };

        case ACTIONS.POST_SEARCHED_GLOBAL_CONTENT_ROWS:
            reduced = (action.payload.globalContentRows || []).reduce((prev, globalContentRow) => {
                prev[globalContentRow._id] = globalContentRow;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById,
                filteredById: reduced,
                sortOrder: action.payload.sortOrder
            };

        case ACTIONS.CLEAR_SEARCHED_GLOBAL_CONTENT_ROWS:
            return {
                ...state,
                filteredById: {}
            };

        default:
            return state;
    }
};
